

























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"])
})
export default class ChargeSet extends Vue {
    @Prop({ type: Object })
    bookData?: Charge.Charge;

    monthFee: number | null = null;
    feeChoose: string[] = ["月付", "季付", "半年付", "年付"];
    chargeMethod: string | null = "";
    bookFee: number = 0;

    mounted() {
        if (this.bookData) {
            if (this.bookData.monthlyCharge == null) {
                if (this.bookData.addtax == "小规模纳税人") {
                    this.monthFee = 125;
                } else {
                    this.monthFee = 250;
                }
            } else {
                this.monthFee = this.bookData.monthlyCharge;
            }

            if (this.bookData.chargeMethod == null) {
                this.chargeMethod = this.feeChoose[3];
            } else {
                this.chargeMethod = this.bookData.chargeMethod;
            }

            if (this.bookData.annualCharge == null) {
                this.bookFee = 200;
            } else {
                this.bookFee = this.bookData.annualCharge;
            }

            if (this.bookData.chargeStartPeriod !== null) {
                this.startPeriod = this.bookData.chargeStartPeriod
            }
        }
    }

    @Watch("bookData")
    bookDataChange(val: Charge.Charge) {
        if (val.monthlyCharge == null) {
            if (val.addtax == "小规模纳税人") {
                this.monthFee = 125;
            } else {
                this.monthFee = 250;
            }
        } else {
            this.monthFee = val.monthlyCharge;
        }

        if (val.chargeMethod == null) {
            this.chargeMethod = this.feeChoose[3];
        } else {
            this.chargeMethod = val.chargeMethod;
        }
        if (val.annualCharge == null) {
            this.bookFee = 200;
        } else {
            this.bookFee = val.annualCharge;
        }
    }

    // 确定
    save() {
        if (this.monthFee != null) {
            if (this.bookData) {
                Vue.axios
                    .post(`charge/set`, {
                        id: this.bookData.id,
                        monthlyCharge: this.monthFee,
                        annualCharge: this.bookFee,
                        chargeMethod: this.chargeMethod,
                        startPeriod: this.startPeriod
                    })
                    .then(res => {
                        let monthlyCharge = this.monthFee;
                        let annualCharge = this.bookFee;
                        let chargeMethod = this.chargeMethod;
                        let startPeriod = this.startPeriod;
                        let val = {
                            monthlyCharge,
                            annualCharge,
                            chargeMethod,
                            startPeriod
                        };
                        this.$emit("success", val);
                    });
            }
        }
    }
    // 关闭弹窗
    close() {
        this.$emit("close");
    }

    startPeriod: null | string = null;
}
